<template>
    <div class="mt-5 card px-3 pt-2 pb-3">
        <div class="d-flex">
            <h5 class="h5 flex-grow-1">Print Report</h5>
            <Check-all-button @input="checkall"></Check-all-button>
        </div>
        <div class="row mb-2">
            <div 
                v-for="d in dates"
                class="col-4 col-sm-3 col-md-3 col-lg-2">
                <button                  
                    class="col-12 btn-sm btn my-1" 
                    :class="isActive(d.id) ? 'btn-secondary' : 'btn-outline-secondary'"
                    @click="toggleDate(d.id) "
                    :key="`button-${d.id}`"
                    >
                    <i class="far fa-calendar me-1"></i>{{ formatDate(d.evaluation_date) }}
                </button>
            </div>
        </div>

        <div class="d-flex justify-content-around col-12 col-md-6 col-lg-4">
            <button type="button" class="btn btn-primary" @click="print('i')"><i class="fas fa-file-invoice me-2"></i>Int<span class="d-none d-sm-inline">ervention</span></button>
            <button type="button" class="btn btn-primary" @click="print('1')"><i class="fas fa-file-invoice me-2"></i>1&nbsp;Col<span class="d-none d-sm-inline">umn</span></button>
            <button type="button" class="btn btn-primary" @click="print('2')"><i class="fas fa-file-invoice me-2"></i>2&nbsp;Col<span class="d-none d-sm-inline">umn</span></button>
            <button type="button" class="btn btn-primary" @click="print('4')"><i class="fas fa-file-invoice me-2"></i>4&nbsp;Col<span class="d-none d-sm-inline">umn</span></button>
        </div>
    </div>
</template>

<script>
import { DateTime } from "luxon";
import CheckAllButton from "./CheckAllButton.vue";

export default {
    components: { DateTime, CheckAllButton },

    props: {
        dates: {
            type: Array,
            default: [],
        },
    },

    data() {
        return {
            reportDates: this.dates,
        };
    },

    watch: {
        /**
         * The reportDate value was being set before the dates prop
         * was being populated.
         */
        dates: function(n, o) {
            this.reportDates = n;
        }
    },

    methods: {
        /**
         * Converts SQL date (YYYY-MM-DD) to locale string
         * 
         * @param (string) date 
         */
         formatDate: function(date_sql) {
            return DateTime.fromSQL(date_sql).startOf('day').toLocaleString(DateTime.DATE_SHORT);
        },

        print: function(columns) {
            let reportDates = this.reportDates.length ? this.reportDates : [ this.$parent.activeDate ];
            // reportDates = reportDates.map((e) => e.evaluation_date);
            reportDates = reportDates.map((e) => e.id);
            const worksheet = this.$parent.worksheet;
            const qstring = `ws=${worksheet}&d=${reportDates.join(',')}&c=${columns}`;
            
            window.open(`/worksheet?${qstring}`);
        },

        toggleDate: function(id) {
            const idx = this.reportDates.findIndex(e => e.id == id);
            if (idx === -1) {
                this.reportDates.push(this.dates.find((e) => e.id == id));
            } else {
                this.reportDates = this.reportDates.filter((e) => e.id != id);
            }
        },

        isActive: function(id) {
            return undefined !== this.reportDates.find((e) => e.id == id);
        },

        checkall: function(value) {
            this.reportDates = value ? this.dates : [];
        }
    }
}
</script>